class CrossReferences {
    constructor(fromReference, toReferences) {
        this.fromReference = fromReference;
        this.toReferences = toReferences;
    }
}

export {
    CrossReferences
}